import eventMixin from '../lib/eventMixin';
import Logger from '../utilities/Logger';
import ThemeMediaLightbox from '../partials/themeMediaLightbox';

export default class ThemeImageGrid {

	constructor(dom) {
		this.dom = dom;
		this.gridItems = this.dom.querySelectorAll('[data-theme-image-grid-item]');
	}

	init() {

		Logger.info('ThemeImageGrid: initializing...');

		const self = this;

		// Listen for clicks
		this.gridItems.forEach((item) => {
			item.addEventListener('click', (e) => {
				e.preventDefault();

				Logger.info('Sending open request...');

				const mediaItemsString = item.getAttribute('data-theme-image-grid-item');
				const mediaItems = mediaItemsString ? mediaItemsString.split(',') : [];

				const openEvent = new CustomEvent(ThemeMediaLightbox.events.open, {
				  detail: {
				  	mediaItems : mediaItems.map((item) => {
              const parts = item.split('|');
				  		return parts[0] == 'image' ? { type: 'image', src: parts[1] } : { type: 'vimeo', id: parts[1] };
				  	})
				  },
				  bubbles: true,
				  cancelable: true,
				  composed: false,
				});
				document.dispatchEvent(openEvent);

			});
		});
	}

}

// Mixins
Object.assign(ThemeImageGrid.prototype, eventMixin);
